import * as uuid from 'uuid';

export class Listener {
  callbacks = {};

  constructor() {
  }

  Subscribe(event, f) {
    const id = uuid.v4();
    if (!this.callbacks[event]) this.callbacks[event] = {};
    this.callbacks[event][id] = f
  }

  Unsubscribe(id) {
    const events = Object.keys(this.callbacks).map(event => this.callbacks[event]);
    for (const event of events) {
      delete event[id]
    }
  }

  Run(event, ...params) {
    if (!this.callbacks[event]) return;
    const callbacks = Object.keys(this.callbacks[event]).map(key => this.callbacks[event][key]);
    for (const callback of callbacks) {
      callback(...params);
    }
  }

}